<ng-container *ngIf="!badge.isPromoBadge; else promoBadgeTemplate">
    <div class="card-league" *ngIf="badge.shouldShow">
        <vn-icon class="icon-alignment" size="11" [name]="badge.icon"></vn-icon>
        <span class="special-card-league-text">{{ badge.title }}</span>
    </div>
</ng-container>
<ng-template #promoBadgeTemplate>
    <ms-promotion-badge class="card-promotional"></ms-promotion-badge>
</ng-template>
